import Vue from 'vue'
import Vuex from 'vuex'
import { parse, format } from 'date-fns'

Vue.use(Vuex)

const state = {
  assets: {},
  filters: [],
  activeFilters: [],
  activeDates: [],
  selectedDate: null,
  results: {},
  resultsOffset: 0,
  paginationLength: 5,
  isLoading: false,
  lastQueryStr: null,
  searchTerm: null
}

const getters = {
  currentQueryStr: (state) => {
    const categories = state.activeFilters.map(f => f.id)
    const offset = state.resultsOffset
    const search = state.searchTerm === null ? '' : state.searchTerm
    const selectedDate = state.selectedDate

    const parts = {}

    if (selectedDate) {
      parts.date = selectedDate
    }

    if (categories.length) {
      parts.categories = categories.join(',')
    }

    if (offset) {
      parts.offset = offset
    }

    if (search) {
      parts.search = search
    }

    const str = []

    if (Object.entries(parts).length) {
      for (const [key, value] of Object.entries(parts)) {
        str.push(`${key}=${value}`)
      }

      return `?${str.join('&')}`
    }

    return ''
  },

  currentFilters: (state) => {
    let filterParts = []

    if (state.activeFilters.length) {
      filterParts.push(state.activeFilters.map(f => f.title).join(', '))
    }

    if (state.searchTerm) {
      filterParts.push(state.searchTerm)
    }

    if (state.selectedDate) {
      const formattedDate = format(parse(state.selectedDate), 'MMMM Do, YYYY')

      filterParts.push(formattedDate)
    }

    if (filterParts.length) {
      return filterParts.join(', ')
    }

    return false
  }
}

const mutations = {
  setActiveFiltersOption (state, filter) {
    const activeFilterIndex = state.activeFilters.findIndex(currentFilter => currentFilter.id === filter.id)

    if (activeFilterIndex > -1) {
      state.activeFilters.splice(activeFilterIndex, 1)
    } else {
      state.activeFilters.push(filter)
    }

    state.selectedDate = null
    state.searchTerm = null

    this.dispatch('fetchResults')
  },

  loadInitialData(state, initialData) {
    state.assets = initialData.assets
    state.filters = initialData.filters
    state.results = initialData.results
    state.resultsOffset = initialData.resultsOffset
    state.searchTerm = initialData.search
    state.selectedDate = initialData.selectedDate
    state.activeDates = initialData.activeDates

    if (initialData.activeCategories.length) {
      state.activeFilters = initialData.filters.filter(f => initialData.activeCategories.indexOf(f.id) !== -1)
    }
  },

  updateLastQueryStr(state) {
    state.lastQueryStr = this.getters.currentQueryStr
  },

  setQueryStr() {
    window.history.replaceState('', '', `${window._eventsRootUrl}${this.getters.currentQueryStr}`)
  },

  clearFilters(state) {
    state.activeFilters = []
    state.searchTerm = null
    state.selectedDate = null

    this.dispatch('fetchResults')
  },

  clearOffset(state) {
    state.resultsOffset = 0

    this.dispatch('fetchResults')
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading
  },

  setSearch(state, searchTerm) {
    if (searchTerm === '') {
      state.searchTerm = null
    } else {
      state.searchTerm = searchTerm.toLowerCase()
    }

    state.activeFilters = []
    state.selectedDate = null

    this.dispatch('fetchResults')
  },

  updateResults(state, newResults) {
    state.results = newResults
  },

  loadMore(state) {
    state.resultsOffset = state.resultsOffset + 1

    this.dispatch('loadMoreResults')
  },

  updateMoreResults(state, newResults) {
    state.results.groups = state.results.groups.concat(newResults.groups)
    state.results.has_more = newResults.has_more
  },

  setSelectedDate(state, newDate) {
    state.searchTerm = null
    state.selectedDate = newDate

    this.dispatch('fetchResults')
  }
}

const actions = {
  loadMoreResults({ state, commit, getters }) {
    if (state.lastQueryStr !== getters.currentQueryStr) {
      commit('updateLastQueryStr')
      commit('setLoading', true)

      const endpoint = window._eventsApiEndpoint.split('?')[0] + '/results'

      $.ajax(endpoint + getters.currentQueryStr)
        .then(resp => {
          commit('updateMoreResults', resp.results)
          commit('setLoading', false)
          commit('setQueryStr')
        })
    }
  },

  fetchResults({ state, commit, getters }) {
    state.resultsOffset = 0

    if (state.lastQueryStr !== getters.currentQueryStr) {
      commit('updateLastQueryStr')
      commit('setLoading', true)

      const endpoint = window._eventsApiEndpoint.split('?')[0] + '/results'

      $.ajax(endpoint + getters.currentQueryStr)
        .then(resp => {
          commit('updateResults', resp.results)
          commit('setLoading', false)
          commit('setQueryStr')
        })
    }
  }
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})
